import _ from 'lodash'

var AutoScroll = function (opts, canvas, onScroll = () => {}) {
  if (!canvas) {
    throw new Error('Canvas is required for scrolling')
  }
  this._canvas = canvas
  this._onScroll = onScroll
  this._interval = null
  this._step = opts.step
  this._threshold = opts.threshold
  this.x = opts.x
  this.y = opts.y

  this._autoScrolled = {
    x: 0,
    y: 0
  }
}

AutoScroll.prototype.start = function () {
  if (this._interval) {
    window.clearInterval(this._interval)
  }
  this._interval = window.setInterval(this._scroll.bind(this), 20)
}

AutoScroll.prototype.mouse = function (coords) {
  this._mouseCoords = coords
}

AutoScroll.prototype._scroll = function () {
  if (!this._mouseCoords) {
    return
  }

  var container = this._canvas.getParent().get(0)
    , bounds = container.getBoundingClientRect()
    , adjust = false

  if (this.x) {
    if (this._mouseCoords.x > bounds.right - this._threshold) {
      // Slide to the right
      this._canvas.$el.width(this._canvas.$el.width() + this._step)
      container.scrollLeft += this._step
      this._autoScrolled.x += this._step
      adjust = true
    } else if (this._mouseCoords.x < bounds.left + this._threshold && container.scrollLeft > 0) {
      // Slide to the left
      container.scrollLeft -= this._step
      this._autoScrolled.x -= this._step
      adjust = true
    }
  }

  if (this.y) {
    if (this._mouseCoords.y > bounds.bottom - this._threshold) {
      // Slide down
      this._canvas.$el.height(this._canvas.$el.height() + this._step)
      container.scrollTop += this._step
      this._autoScrolled.y += this._step
      adjust = true
    } else if (this._mouseCoords.y < bounds.top + this._threshold && container.scrollTop > 0) {
      // Slide up
      container.scrollTop -= this._step
      this._autoScrolled.y -= this._step
      adjust = true
    }
  }
  if (adjust) {
    this._onScroll()
  }
}

AutoScroll.prototype.stop = function () {
  if (this._interval) {
    window.clearInterval(this._interval)
    this._interval = null
  }
  this._autoScrolled = {
    x: 0,
    y: 0
  }
  this.pos = null
}

export default AutoScroll
